import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../components/FilterBar/FilterBar';
import ResetFiltersButton from '../../components/FilterBar/ResetFiltersButton';
import { GenericStatusPicker } from '../../components/GenericStatusPicker';
import { getStringSearchPlaceholder } from '../../helpers/search';
import { searchFields } from './Customers';

export type CustomerFilters = {
  status?: 'ACTIVE' | 'INACTIVE';
  stringSearch?: string | undefined;
};

type FilterBarCustomerProps = FilterBarProps<CustomerFilters>;

export const defaultFilters: CustomerFilters = {
  status: 'ACTIVE',
  stringSearch: undefined,
};

const FilterBarCustomer: React.FC<FilterBarCustomerProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (e: any) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          name="stringSearch"
          autoFocus={isBrowser && !selectedId}
          width={350}
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
        <GenericStatusPicker
          value={filters.status}
          isClearable
          onChange={(value) => {
            setFilters({
              ...filters,
              status: value,
            });
          }}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

FilterBarCustomer.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarCustomer;
